<template lang="pug">
.facility-accept-mark.d-flex.flex-column.justify-content-center.align-items-stretch(:class="{ 'accept': _value, 'not-accept': !_value }")
  .text-center(:class="{ 'accept-mark': _value, 'not-accept-mark': !_value }") {{ _getMark }}
  .accept-text.text-center {{ _getText }}
  
</template>

<script lang="ts">
import { Component, Prop, Vue } from "vue-property-decorator";

/**
 * ### 受入可／受入不可 コンポーネント
 *
 * - 施設情報などで使用する、受入可／受入不可を示す文字アイコン
 */
@Component
export default class FacilityAcceptMark extends Vue {
  /** 受入可／受入不可 */
  @Prop()
  value!: boolean;

  get _value(): boolean {
    return this.value;
  }

  get _getMark(): string {
    if (this._value) {
      return "○";
    } else {
      return "×";
    }
  }

  get _getText(): string {
    if (this._value) {
      return "受入可";
    } else {
      return "受入不可";
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../styles/pc/_colors.scss";

.facility-accept-mark {
  min-width: 42px;
  min-height: 36px;
  border: solid 1px;
  border-radius: 0.25rem;

  &.accept {
    color: $font-key-color;
  }
  &.not-accept {
    color: $font-disable-font-color;
  }

  .accept-mark {
    margin: -2px -6px -4px -6px;
    font-size: 16px;
    font-weight: bold;
  }
  .not-accept-mark {
    margin: -2px -6px -6px -6px;
    font-size: 20px;
    font-weight: bold;
  }
  .accept-text {
    font-size: 9px;
  }
}
</style>
